import {useLayoutEffect, useRef} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCopy} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";
import toast from "react-hot-toast";

export default function TextareaWithClipboard({value, showButton}) {
    let {t} = useTranslation();
    const textareaRef = useRef(null);

    useLayoutEffect(() => {
        const fitTextareaToContent = () => {
            const textarea = textareaRef.current;

            if (!textarea) {
                return;
            }

            textarea.style.height = 'auto';
            const borderHeight = textarea.offsetHeight - textarea.clientHeight;
            textarea.style.height = `${textarea.scrollHeight + borderHeight}px`;
        };

        fitTextareaToContent();
        window.addEventListener('resize', fitTextareaToContent);

        return () => window.removeEventListener('resize', fitTextareaToContent);
    }, [value]);

    const copyTextareaContents = () => {
        const textarea = textareaRef.current;
        textarea.select();
        navigator.clipboard.writeText(textarea.value).then(() => {
            toast.success(t('copy-to-clipboard-success'));
        }).catch(() => {
            toast.error(t('copy-to-clipboard-failed'));
        });
    };

    return <div className={'relative'}>
        <textarea
            className={'form-input w-full resize-none overflow-hidden rounded-lg bg-slate-50 px-4 py-3 pr-14 font-mono text-sm leading-6 text-slate-700'}
            ref={textareaRef}
            value={value}
            readOnly={true}
            spellCheck={false}
            aria-label={t('code-to-copy')}
        />
        {showButton &&
            <button
                type={'button'}
                className={'absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-lg border border-violet-200 bg-white text-violet-600 shadow-sm transition-colors hover:border-violet-300 hover:bg-violet-50 focus:outline-none focus:ring-2 focus:ring-violet-300'}
                title={t('copy-to-clipboard')}
                aria-label={t('copy-to-clipboard')}
                onClick={copyTextareaContents}
            >
                <FontAwesomeIcon icon={faCopy}/>
            </button>
        }
    </div>;
}
